export function instantScrollTo(position: ScrollToOptions) {
  if (typeof window === 'undefined') {
    throw new TypeError('Cannot use this function outside a window context');
  }

  window.scrollTo({ top: position.top, left: position.left, behavior: 'instant' });
}
